import type { UsageTier } from "@amoreg/contracts";

/**
 * Series and table order. The chart layers both tiers from a shared zero
 * baseline, so this only fixes the reading order of legends, tables and hover
 * rows; it does not decide which series sits above the other.
 */
export const TIER_ORDER: readonly UsageTier[] = ["amoregFlash", "amoreg", "amoregPro"];

/**
 * The composer's own names — the page speaks the product's models, not
 * vendors. Ultrafast turns, on whichever model, have their own line: they
 * cost six times the standard rate.
 */
export const TIER_LABEL: Record<UsageTier, string> = {
  amoregFlash: "Ultrafast",
  amoreg: "Amoreg",
  amoregPro: "Amoreg Pro",
};

/**
 * One product, three tiers, so the key is colour rather than a brand mark:
 * Flash takes a cool accent, the standard tier the neutral, Pro the warm
 * accent. Which vendor serves any tier is not something this page says, and
 * should not be — the lineup behind each has already changed more than once.
 */
export const TIER_COLOR: Record<UsageTier, string> = {
  amoregFlash: "#6aa1d8",
  amoreg: "#e6e6e6",
  amoregPro: "#d97757",
};

/**
 * The tiers worth drawing, in reading order.
 *
 * The page only shows tiers that actually served something: a legend entry, a
 * hover row and a table column for a tier this organization has never used are
 * three pieces of furniture that answer nothing.
 */
export function activeTiers(present: Iterable<UsageTier>): readonly UsageTier[] {
  const seen = new Set(present);
  return TIER_ORDER.filter((tier) => seen.has(tier));
}
